import React from "react";
import {Route, Routes} from "react-router-dom";
import CompanyList from "../container/company/CompanyList";
import CreateCompany from "../container/company/CreateCompany";
import UpdateCompany from "../container/company/UpdateCompany";

const Company = () => {
  return (
    <Routes>
      <Route path="/*" element={<CompanyList />} />
      <Route path="Create" element={<CreateCompany />} />
      <Route path="Edit/:id" element={<UpdateCompany />} />
    </Routes>
  );
};

export default Company;
